import React, { useState, useEffect } from "react";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { ReactComponent as Brands } from "../../images/svg/Brands.svg";
import { ReactComponent as Type } from "../../images/svg/Type.svg";
import { ReactComponent as Size } from "../../images/svg/Size.svg";
import { ReactComponent as Color } from "../../images/svg/Color.svg";
import { ReactComponent as Taste } from "../../images/svg/Taste.svg";
import { ReactComponent as Countries } from "../../images/svg/Countries.svg";
import { ReactComponent as Company } from "../../images/svg/Company.svg";
import { ReactComponent as GroupPro } from "../../images/svg/GroupPro.svg";
import { ReactComponent as Target } from "../../images/svg/Target.svg";
import { ReactComponent as Material } from "../../images/svg/Material.svg";
import { ReactComponent as Smell } from "../../images/svg/Smell.svg";
import { ReactComponent as Ingred } from "../../images/svg/Ingred.svg";
import { ReactComponent as Model } from "../../images/svg/Model.svg";
import { ReactComponent as Highlight } from "../../images/svg/Highlight.svg";
import { ReactComponent as UserManagement } from "../../images/svg/UserManagement.svg";
import { ReactComponent as Category } from "../../images/svg/Category.svg";
import { ReactComponent as Product } from "../../images/svg/Product.svg";
import { ReactComponent as Slave } from "../../images/svg/Slave.svg";
import { ReactComponent as FAQ } from "../../images/svg/FAQ.svg";
import { ReactComponent as ProductImages } from "../../images/svg/ProductImages.svg";
import { ReactComponent as Expertreview } from "../../images/svg/Expertreview.svg";
import { ReactComponent as Competitors } from "../../images/svg/Competitors.svg";
import { ReactComponent as ProShield } from "../../images/svg/ProShield.svg";
import { ReactComponent as Home } from "../../images/svg/Home.svg";
import { ReactComponent as UserAcces } from "../../images/svg/UserAcces.svg";
import { ReactComponent as ProductUsage } from "../../images/svg/ProductUsage.svg";
import { ReactComponent as OrderChilde } from "../../images/svg/OrderChilde.svg";
import { ReactComponent as NewOrder } from "../../images/svg/NewOrder.svg";
import { ReactComponent as FirstPageContent } from "../../images/svg/FirstPageContent.svg";
import { ReactComponent as MenuContent } from "../../images/svg/MenuContent.svg";
import { ReactComponent as CommentsManagement } from "../../images/svg/CommentsManagement.svg";
import { ReactComponent as Comments } from "../../images/svg/Comments.svg";
import { ReactComponent as Articles } from "../../images/svg/Articles.svg";
import { ReactComponent as Authors } from "../../images/svg/Authors.svg";
import { ReactComponent as Articlegroups } from "../../images/svg/Articlegroups.svg";
import { ReactComponent as Relatedarticle } from "../../images/svg/Relatedarticle.svg";
import { ReactComponent as Discountmanagment } from "../../images/svg/Discountmanagment.svg";
import { ReactComponent as Productstorage } from "../../images/svg/Productstorage.svg";
import { ReactComponent as Ordersreport } from "../../images/svg/Ordersreport.svg";
import { ReactComponent as Productreport } from "../../images/svg/Productreport.svg";
import { ReactComponent as Generalpages } from "../../images/svg/Generalpages.svg";
import { ReactComponent as Settings } from "../../images/svg/Settings.svg";
import { ReactComponent as Productgifts } from "../../images/svg/Productgifts.svg";
import { ReactComponent as Reminder } from "../../images/svg/Reminder.svg";
import { ReactComponent as OrdersGift } from "../../images/svg/OrdersGift.svg";
import { ReactComponent as UsersWallet } from "../../images/svg/UsersWallet.svg";
import { ReactComponent as WalletManagment } from "../../images/svg/WalletManagment.svg";
import { ReactComponent as Walletreport } from "../../images/svg/Walletreport.svg";
import { ReactComponent as Favoritproducts } from "../../images/svg/Favoritproducts.svg";
import { ReactComponent as Manualsms } from "../../images/svg/Manualsms.svg";
import { ReactComponent as PostDelivery } from "../../images/svg/PostDelivery.svg";
import { ReactComponent as PeykDelivery } from "../../images/svg/PeykDelivery.svg";
import { ReactComponent as Bankterminals } from "../../images/svg/Bankterminals.svg";
import { ReactComponent as Deliverycalendar } from "../../images/svg/Deliverycalendar.svg";
import { ReactComponent as DriverManage } from "../../images/svg/DriverManage.svg";
import { ReactComponent as DeliveryManage } from "../../images/svg/DeliveryManage.svg";
import { ReactComponent as MotorRouting } from "../../images/svg/MotorRouting.svg";
import { ReactComponent as RelatedProducts } from "../../images/svg/RelatedProducts.svg";
import { ReactComponent as MagManagment } from "../../images/svg/MagManagment.svg";
import { ReactComponent as MagAdvManage } from "../../images/svg/MagAdvManage.svg";
import { ReactComponent as InpersonManagment } from "../../images/svg/InpersonManagment.svg";
import { ReactComponent as CustomerRetention } from "../../images/svg/CustomerRetention.svg";
import { ReactComponent as AutoMessage } from "../../images/svg/AutoMessage.svg";
import { ReactComponent as ProductCluster } from "../../images/svg/ProductCluster.svg";
import { ReactComponent as Customers } from "../../images/svg/Customers.svg";
import { ReactComponent as UserPollManagment } from "../../images/svg/UserPollManagment.svg";
import { ReactComponent as Consultant } from "../../images/svg/Consultant.svg";
import { ReactComponent as ManageConsultant } from "../../images/svg/ManageConsultant.svg";
import { ReactComponent as B2BCustomers } from "../../images/svg/B2BCustomers.svg";
import { ReactComponent as B2BOrderReport } from "../../images/svg/B2BOrderReport.svg";
import { ReactComponent as AdvertisingManage } from "../../images/svg/AdvertisingManage.svg";
import { ReactComponent as AdvertismentGroup } from "../../images/svg/AdvertismentGroup.svg";
import { ReactComponent as Advertisments } from "../../images/svg/Advertisments.svg";
import { ReactComponent as AdvertismentContract } from "../../images/svg/AdvertismentContract.svg";
import { ReactComponent as AdvertismentCustomer } from "../../images/svg/AdvertismentCustomer.svg";
import { ReactComponent as Suppliers } from "../../images/svg/Suppliers.svg";
import { ReactComponent as SupplierProducts } from "../../images/svg/SupplierProducts.svg";
import { ReactComponent as SupplierRequest } from "../../images/svg/SupplierRequest.svg";
import { ReactComponent as SupplierOrders } from "../../images/svg/SupplierOrders.svg";
import { ReactComponent as SupplierOffers } from "../../images/svg/SupplierOffers.svg";
import { rsActiveMenu, rsOpenDrawer, rsParentChilds } from "../../RecoilStates";
import { readFromLS, writeToLS } from "../../util/LocalStrogeService";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function MenuRender(props) {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [addresPrint, setAddresPrint] = useState(readFromLS("addresPrint"));
  const [factorPrint, setFactorPrint] = useState(readFromLS("factorPrint"));
  const [factorType, setFactorType] = useState(readFromLS("factorType"));
  const [model, setModel] = React.useState(props.model);
  const [state, setState] = useState({ icon: undefined, url: "" });
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { isSmall } = useBreakpoints();
  const [openDrawer, setOpenDrawer] = useRecoilState(rsOpenDrawer);

  const clearCacheData = () => {
    let configVersion = window.ENV.versionCode;
    let LSVersion = localStorage.getItem("VersionCode");

    if (LSVersion == null && configVersion) {
      window.location.reload(true);
      localStorage.setItem("VersionCode", configVersion);
    } else if (LSVersion !== configVersion) {
      window.location.reload(true);
      localStorage.setItem("VersionCode", configVersion);
    } else if (LSVersion === configVersion) {
    }
  };
  const [parentID, setParentID] = useRecoilState(rsParentChilds);

  const handleClick = () => {
    setOpenDrawer(false);
    if (
      model.pageAddress == "orders" &&
      !addresPrint &&
      !factorPrint &&
      !factorType
    ) {
      enqueueSnackbar("لطفا ابتدا تنظیمات را تکمیل کنید", {
        variant: "error",
        autoHideDuration: 2000,
      });
      navigate("/setting");
      return;
    }
    clearCacheData();
    setMsActiveMenu(model);
    navigate(state.url);

    setParentID({
      id: null,
      name: "",
      scrolParent: { top: 0, left: 0 },
    });
  };

  useEffect(() => {
    binding(model.pageAddress);
  }, []);

  return (
    <Stack sx={{ mb: 1 }}>
      <ListItemButton
        sx={{ pl: props.isChild && 4, alignItems: "center" }}
        onClick={handleClick}
        selected={msActiveMenu.id == model.id}
      >
        <ListItemIcon sx={{ minWidth: "30px" }}>
          {state.icon ? state.icon : ""}
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{
            fontSize: 14,
          }}
          primary={model.pageTitle}
        />
      </ListItemButton>
    </Stack>
  );

  function binding(val) {
    switch (val) {
      case "users":
        setState({
          icon: <UserManagement style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/users",
        });
        break;
      case "useraccess":
        setState({
          icon: <UserAcces style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/useraccess",
        });
        break;
      case "Home":
        setState({
          icon: <Home style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/",
        });
        break;
      case "brands":
        setState({
          icon: <Brands style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/brands",
        });
        break;
      case "producttypes":
        setState({
          icon: <Type style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/producttypes",
        });
        break;
      case "productsize":
        setState({
          icon: <Size style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/productsize",
        });
        break;
      case "productcolors":
        setState({
          icon: <Color style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/productcolors",
        });
        break;
      case "producttaste":
        setState({
          icon: <Taste style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/producttaste",
        });
        break;
      case "Countries":
        setState({
          icon: <Countries style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/Countries",
        });
        break;
      case "companies":
        setState({
          icon: <Company style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/companies",
        });
        break;
      case "categories":
        setState({
          icon: <Category style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/categories",
        });
        break;
      case "productgroups":
        setState({
          icon: <GroupPro style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/productgroups",
        });
        break;
      case "productshield":
        setState({
          icon: <ProShield style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/productshield",
        });
        break;
      case "targetlocation":
        setState({
          icon: <Target style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/targetlocation",
        });
        break;
      case "productmaterial":
        setState({
          icon: <Material style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/productmaterial",
        });
        break;
      case "productscent":
        setState({
          icon: <Smell style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/productscent",
        });
        break;
      case "ingredients":
        setState({
          icon: <Ingred style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/ingredients",
        });
        break;
      case "models":
        setState({
          icon: <Model style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/models",
        });
        break;
      case "highlights":
        setState({
          icon: <Highlight style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/highlights",
        });
        break;
      case "appropriate":
        setState({
          icon: <ProductUsage style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/appropriate",
        });
        break;
      case "products":
        setState({
          icon: <Product style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/products",
        });
        break;
      case "productimages":
        setState({
          icon: <ProductImages style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/productimages",
        });
        break;
      case "productvideos":
        setState({
          icon: <ProductImages style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/productvideos",
        });
        break;
      case "slaveproducts":
        setState({
          icon: <Slave style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "/slaveproducts",
        });
        break;
      case "competitors":
        setState({
          icon: <Competitors style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "competitors",
        });
        break;
      case "faq":
        setState({
          icon: <FAQ style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "faq",
        });
        break;
      case "expertreview":
        setState({
          icon: <Expertreview style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "expertreview",
        });
        break;
      case "homepagemanage":
        setState({
          icon: (
            <FirstPageContent style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "homepagemanage",
        });
        break;
      case "landingmanagment":
        setState({
          icon: (
            <FirstPageContent style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "landingmanagment",
        });
        break;
      case "menues":
        setState({
          icon: (
            <MenuContent
              style={{ width: isSmall ? "18px" : "22px", fill: "#fff" }}
            />
          ),
          url: "menues",
        });
        break;
      case "orders":
        setState({
          icon: <OrderChilde style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "orders",
        });
        break;
      case "ordermodify":
        setState({
          icon: <NewOrder style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "ordermodify",
        });
        break;
      case "managecomments":
        setState({
          icon: (
            <CommentsManagement style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "managecomments",
        });
        break;
      case "comments":

      case "comments":
        setState({
          icon: <Comments style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "comments",
        });
        break;
      case "articles":
        setState({
          icon: <Articles style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "articles",
        });
        break;
      case "authors":
        setState({
          icon: <Authors style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "authors",
        });
        break;
      case "articlegroups":
        setState({
          icon: <Articlegroups style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "articlegroups",
        });
        break;
      case "relatedarticle":
        setState({
          icon: <Relatedarticle style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "relatedarticle",
        });
        break;
      case "discountmanagment":
        setState({
          icon: (
            <Discountmanagment style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "discountmanagment",
        });
        break;
      case "ordersreport":
        setState({
          icon: <Ordersreport style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "ordersreport",
        });
        break;
      case "productreport":
        setState({
          icon: <Productreport style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "productreport",
        });
        break;
      case "generalpages":
        setState({
          icon: <Generalpages style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "generalpages",
        });
        break;
      case "productstorage":
        setState({
          icon: <Productstorage style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "productstorage",
        });
        break;
      case "settings":
        setState({
          icon: <Settings style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "settings",
        });
        break;
      case "productgifts":
        setState({
          icon: <Productgifts style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "productgifts",
        });
        break;
      case "ordergifts":
        setState({
          icon: <OrdersGift style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "ordergifts",
        });
        break;
      case "reminder":
        setState({
          icon: <Reminder style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "reminder",
        });
        break;
      case "userswallet":
        setState({
          icon: <UsersWallet style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "userswallet",
        });
        break;
      case "walletManagment":
        setState({
          icon: (
            <WalletManagment style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "walletManagment",
        });
        break;
      case "walletreport":
        setState({
          icon: <Walletreport style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "walletreport",
        });
        break;
      case "favoritproducts":
        setState({
          icon: (
            <Favoritproducts style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "favoritproducts",
        });
        break;
      case "manualsms":
        setState({
          icon: <Manualsms style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "manualsms",
        });
        break;
      case "motordelivery":
        setState({
          icon: <PeykDelivery style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "motordelivery",
        });
        break;
      case "drivermanage":
        setState({
          icon: <DriverManage style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "drivermanage",
        });
        break;
      case "deliverymanage":
        setState({
          icon: <DeliveryManage style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "deliverymanage",
        });
        break;
      case "motorrouting":
        setState({
          icon: <MotorRouting style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "motorrouting",
        });
        break;
      case "postdelivery":
        setState({
          icon: <PostDelivery style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "postdelivery",
        });
        break;
      case "bankterminals":
        setState({
          icon: <Bankterminals style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "bankterminals",
        });
        break;
      case "deliverycalendar":
        setState({
          icon: (
            <Deliverycalendar style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "deliverycalendar",
        });
        break;
      case "inpersonmanagment":
        setState({
          icon: (
            <InpersonManagment style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "inpersonmanagment",
        });
        break;
      case "relatedproducts":
        setState({
          icon: (
            <RelatedProducts style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "relatedproducts",
        });
        break;
      case "magmanagment":
        setState({
          icon: <MagManagment style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "magmanagment",
        });
        break;
      case "magadvmanage":
        setState({
          icon: <MagAdvManage style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "magadvmanage",
        });
        break;
      case "customerretention":
        setState({
          icon: (
            <CustomerRetention style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "customerretention",
        });
        break;
      case "automessage":
        setState({
          icon: <AutoMessage style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "automessage",
        });
        break;
      case "productcluster":
        setState({
          icon: <ProductCluster style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "productcluster",
        });
        break;
      case "customers":
        setState({
          icon: <Customers style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "customers",
        });
        break;
      case "userpollmanagment":
        setState({
          icon: (
            <UserPollManagment style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "userpollmanagment",
        });
        break;
      case "consulators":
        setState({
          icon: <Consultant style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "consulators",
        });
        break;
      case "consulate":
        setState({
          icon: <Consultant style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "consulate",
        });
        break;
      case "manageconsulators":
        setState({
          icon: <Consultant style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "manageconsulators",
        });
        break;
      case "manageconsulate":
        setState({
          icon: (
            <ManageConsultant style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "manageconsulate",
        });
        break;
      case "b2bcustomers":
        setState({
          icon: <B2BCustomers style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "b2bcustomers",
        });
        break;
      case "b2borders":
        setState({
          icon: <B2BCustomers style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "b2borders",
        });
        break;
      case "shortlink":
        setState({
          icon: <B2BCustomers style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "shortlink",
        });
        break;
      case "deliveryreport":
        setState({
          icon: <Ordersreport style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "deliveryreport",
        });
        break;
      case "b2borderreport":
        setState({
          icon: <B2BOrderReport style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "b2borderreport",
        });
        break;
      case "advertisingmanage":
        setState({
          icon: (
            <AdvertisingManage style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "advertisingmanage",
        });
        break;
      case "advertismentgroup":
        setState({
          icon: (
            <AdvertismentGroup style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "advertismentgroup",
        });
        break;
      case "advertisments":
        setState({
          icon: <Advertisments style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "advertisments",
        });
        break;
      case "advertismentcontract":
        setState({
          icon: (
            <AdvertismentContract
              style={{ width: isSmall ? "18px" : "22px" }}
            />
          ),
          url: "advertismentcontract",
        });
        break;
      case "advertismentcustomers":
        setState({
          icon: (
            <AdvertismentCustomer
              style={{ width: isSmall ? "18px" : "22px" }}
            />
          ),
          url: "advertismentcustomers",
        });
        break;
      case "pagevisit":
        setState({
          icon: (
            <AdvertismentCustomer
              style={{ width: isSmall ? "18px" : "22px" }}
            />
          ),
          url: "pagevisit",
        });
        break;
      case "searchadvmanage":
        setState({
          icon: (
            <AdvertismentCustomer
              style={{ width: isSmall ? "18px" : "22px" }}
            />
          ),
          url: "searchadvmanage",
        });
        break;
      case "expressmanage":
        setState({
          icon: (
            <AdvertismentCustomer
              style={{ width: isSmall ? "18px" : "22px" }}
            />
          ),
          url: "expressmanage",
        });
        break;
      case "paymentmanagment":
        setState({
          icon: <Bankterminals style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "paymentmanagment",
        });
        break;
      case "installmentreports":
        setState({
          icon: <Bankterminals style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "installmentreports",
        });
        break;
      case "consulatororders":
        setState({
          icon: <Ordersreport style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "consulatororders",
        });
        break;
      case "expressorderreports":
        setState({
          icon: <Ordersreport style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "expressorderreports",
        });
        break;
      case "suppliers":
        setState({
          icon: <Suppliers style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "suppliers",
        });
        break;
      case "supplierproducts":
        setState({
          icon: (
            <SupplierProducts style={{ width: isSmall ? "18px" : "22px" }} />
          ),
          url: "supplierproducts",
        });
        break;
      case "supplierrequest":
        setState({
          icon: (
            <SupplierRequest style={{ width: isSmall ? "18px" : "22px" }} />
          ),

          url: "supplierrequest",
        });
        break;
      case "supplieroffers":
        setState({
          icon: <SupplierOffers style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "supplieroffers",
        });
        break;
      case "supplierorders":
        setState({
          icon: <SupplierOrders style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "supplierorders",
        });
        break;
      case "discountcodereports":
        setState({
          icon: <Ordersreport style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "discountcodereports",
        });
        break;
      case "festivalmanagment":
        setState({
          icon: <Ordersreport style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "festivalmanagment",
        });
        break;
      case "fractionallist":
        setState({
          icon: <Ordersreport style={{ width: isSmall ? "18px" : "22px" }} />,
          url: "fractionallist",
        });
        break;
      default:
        break;
    }
  }
}
